import React,{useState} from 'react'
import SidebarOfsDash from './subComponents/SidebarOfsDash'
import HeaderOfstuDashComp from './subComponents/HeaderOfstuDashComp'
import { headerprops, noticeData, noticeDataGreetings, noticeGreetingsdaydate, notificationstuboxApi } from '../../../utils/DashboardApi/StudentDashboardApi'
import {Row,Col} from 'react-bootstrap'
import NotificationboxComp from '../commonSybcomponent/NotificationboxComp'
import { Accordion } from 'react-bootstrap';
const StuDashNoticeComp = () => {
    function replaceWithBr(body) {
        return body.replace(/\n/g, "<br />")
        }
        const [shownotificationbox,setshownotificationbox] = useState(false)
    
      function funcnotification(){
          
          setshownotificationbox(!shownotificationbox);
        }
        const [activeKey, setActiveKey] = useState(null);
        const handleAccordionToggle = (eventKey) => {
            setActiveKey(eventKey);
            // eventKey == activeKey ? null : 
        };
  return (
    <>
        <div className="stu_dash_mainWrap">
        <SidebarOfsDash activeID="2"/>
        <div className="rightpartcontentwrap">
        <HeaderOfstuDashComp func={funcnotification} heading="Notice" myprops={headerprops}/>
            {
                shownotificationbox == true ?
                <NotificationboxComp api={notificationstuboxApi}/>
                :
                ""
            }
            <div className="tabPane">
            <div className="tabpaneheightadjust">
            <Row>
                <Col lg={12}>
               
                    <div className="noticetabbox">
                        
                        {
                        noticeData.map((item,key)=>{
                            return(
                                    <div key={key} className="noticetabboxbarstudash">
                        <Accordion onSelect={handleAccordionToggle} className='myaccordionnotice  noticeboxleft' defaultActiveKey="0" key={key}>
                        <Accordion.Item style={activeKey == key ? { border: "1px solid rgba(0,0,0,0.7)" } : { border: "1px solid rgba(0,0,0,0.2)" }} eventKey={`${key}`}>
                          <Accordion.Header>
                           
                             
                                <div className="dateofnoticebox">
                                    <h5>{item.publishDateDayMonth}<br/>{item.publishDateYear}</h5>
                                </div>
                              
                                <h3>{item.noticeheading} - Published : {item.publishDate}</h3>
                               
                          {/* <h3>{item.noticeheading} - <span>Published : {item.publishDate}</span></h3> */}
                          </Accordion.Header>
                          <Accordion.Body className='accbody'>
                            {/* <p>{trimmedString}...</p> */}
                            <p dangerouslySetInnerHTML={{__html: replaceWithBr(item.body)}} ></p>

                          </Accordion.Body>
                        </Accordion.Item>

                      </Accordion>
                      </div>

                            )
                        })
                    } 
                    {/* {
                        noticeData.map((item,key)=>{
                            return(
                                    <div key={key} className="noticetabboxbar">
                                        <div className="dateofnoticebox">
                                            <h5>{item.publishDateDayMonth}<br/>{item.publishDateYear}</h5>
                                        </div>
                                        <h3>{item.noticeheading} - <span>Published : {item.publishDate}</span></h3>
                                    </div>

                            )
                        })
                    } */}
                    </div>
                </Col>
            
            </Row>
            </div>
       
            </div>
        </div>
    </div>
    </>
  )
}

export default StuDashNoticeComp